var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxSecuritySafe2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_3994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2495 7.27477C13.2495 10.3494 11.0174 13.2292 7.96792 14.0717C7.76042 14.1283 7.53401 14.1283 7.32651 14.0717C4.27703 13.2292 2.04492 10.3494 2.04492 7.27477V4.51448C2.04492 3.9989 2.43477 3.41415 2.91892 3.21923L6.42109 1.78567C7.20705 1.465 8.09361 1.465 8.87956 1.78567L12.3818 3.21923C12.8596 3.41415 13.2558 3.9989 13.2558 4.51448L13.2495 7.27477Z",
    stroke: "url(#paint0_linear_21_3994)",
    strokeWidth: 1.00602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25401 8.65939C7.22498 8.65939 7.20144 8.63585 7.20144 8.60682C7.20513 8.26374 7.23925 7.99075 7.30381 7.78785C7.37022 7.58495 7.46429 7.42079 7.58603 7.29536C7.70776 7.16993 7.8544 7.05557 8.02595 6.95228C8.13662 6.88218 8.23622 6.80379 8.32476 6.7171C8.4133 6.63041 8.48339 6.5308 8.53504 6.41828C8.58668 6.30577 8.61251 6.18126 8.61251 6.04477C8.61251 5.8806 8.57377 5.73858 8.4963 5.61868C8.41883 5.49879 8.31554 5.40656 8.18642 5.342C8.05915 5.2756 7.91712 5.2424 7.76033 5.2424C7.6183 5.2424 7.48273 5.27191 7.35362 5.33094C7.2245 5.38996 7.11752 5.48219 7.03267 5.60761C7.01264 5.63678 6.99462 5.66796 6.9786 5.70113C6.8811 5.90305 6.71173 6.08627 6.48751 6.08627C6.24591 6.08627 6.04517 5.88214 6.11095 5.64967C6.15315 5.5005 6.21507 5.36566 6.2967 5.24516C6.45164 5.0146 6.65638 4.84029 6.91093 4.72224C7.16732 4.60419 7.45045 4.54517 7.76033 4.54517C8.09973 4.54517 8.3967 4.6088 8.65124 4.73608C8.90579 4.8615 9.10315 5.03766 9.24333 5.26453C9.38536 5.48956 9.45638 5.75241 9.45638 6.05307C9.45638 6.25966 9.4241 6.44595 9.35954 6.61196C9.29498 6.77612 9.20276 6.92276 9.08286 7.05188C8.96481 7.181 8.82278 7.29536 8.65677 7.39496C8.49999 7.49272 8.37272 7.59417 8.27496 7.69931C8.17904 7.80445 8.10895 7.92895 8.06468 8.07283C8.02041 8.2167 7.99643 8.3947 7.99274 8.60682C7.99274 8.63585 7.96921 8.65939 7.94017 8.65939H7.25401ZM7.61923 10.3416C7.46798 10.3416 7.33794 10.2881 7.22911 10.1811C7.12028 10.0723 7.06587 9.94133 7.06587 9.78824C7.06587 9.63699 7.12028 9.50787 7.22911 9.40089C7.33794 9.29206 7.46798 9.23765 7.61923 9.23765C7.76863 9.23765 7.89775 9.29206 8.00658 9.40089C8.11725 9.50787 8.17259 9.63699 8.17259 9.78824C8.17259 9.88969 8.14676 9.98284 8.09512 10.0677C8.04531 10.1507 7.97891 10.2171 7.89591 10.2669C7.8129 10.3167 7.72068 10.3416 7.61923 10.3416Z",
    fill: "url(#paint1_linear_21_3994)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_3994",
    x1: 7.65037,
    y1: 1.54517,
    x2: 7.65037,
    y2: 14.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_3994",
    x1: 7.75065,
    y1: 4.54517,
    x2: 7.75065,
    y2: 10.3416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6D4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_3994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0903,
    height: 15.0903,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxSecuritySafe2);
export default __webpack_public_path__ + "static/media/iconsax-security-safe2.6139297e44ece9c5d27a1a49dabd4822.svg";
export { ForwardRef as ReactComponent };